"use strict";

import axios from "axios";
import api from "@/api/api";
import userService from "../../services/user.service";
import { CONSTANTS, getErrorMessage } from "../../global/index";

const { GETTING_INFO, GET_INFO_SUCCESS, SET_STATUS, ERROR_MSG, ERROR_STATUS } =
  CONSTANTS;

const ERROR_OBJ = {
  success: false,
  status: ERROR_STATUS,
  code: 500,
  message: ERROR_MSG,
  data: null,
};

const headers = () => ({ Authorization: userService.getToken() });

export default {
  namespaced: true,
  state: {
    loading: false,
    data: [],
    resumen: [],
    status: "",
  },

  getters: {
    loading: (state) => state.loading,
    data: (state) => state.data,
    resumen: (state) => state.resumen,
    status: (state) => state.status,
    total: (state) =>
      state.data.reduce((suma, item) => suma + Number(item.amount || 0), 0),
  },

  mutations: {
    [GETTING_INFO](state) {
      state.loading = true;
    },
    [GET_INFO_SUCCESS](state, change) {
      state.loading = false;
      state.data = change || [];
    },
    [SET_STATUS](state, value) {
      state.status = value;
    },
    SET_RESUMEN(state, value) {
      state.resumen = value || [];
    },
  },

  actions: {
    /** Corte de un mes: min_day y max_day en formato YYYY-MM-DD. */
    async getByDatesInc({ commit }, { min_day, max_day }) {
      commit(GETTING_INFO);
      try {
        const response = await axios.get(
          `/income-dates?min_day=${min_day}&max_day=${max_day}`,
          { headers: headers() }
        );
        commit(GET_INFO_SUCCESS, response.data.data);
        return response.data;
      } catch (error) {
        commit(GET_INFO_SUCCESS, []);
        if (!error?.response?.data?.message) return ERROR_OBJ;
        return getErrorMessage(error.response.data.message);
      }
    },

    async getResumenInc({ commit }, { min_day, max_day }) {
      try {
        const response = await axios.get(
          `/income-resumen?min_day=${min_day}&max_day=${max_day}`,
          { headers: headers() }
        );
        commit("SET_RESUMEN", response.data.data);
        return response.data.data;
      } catch (error) {
        commit("SET_RESUMEN", []);
        return [];
      }
    },

    async addItemInc(_, item) {
      try {
        const response = await api.addItem({ option: "income", item }, headers());
        return response.data;
      } catch (error) {
        if (!error?.response?.data?.message) return ERROR_OBJ;
        return getErrorMessage(error.response.data.message);
      }
    },

    async editItemInc(_, item) {
      try {
        const response = await api.editItem({ option: "income", item }, headers());
        return response.data;
      } catch (error) {
        if (!error?.response?.data?.message) return ERROR_OBJ;
        return getErrorMessage(error.response.data.message);
      }
    },

    async deleteItemInc(_, id) {
      try {
        const response = await api.deleteItem({ option: "income", id }, headers());
        return response.data;
      } catch (error) {
        if (!error?.response?.data?.message) return ERROR_OBJ;
        return getErrorMessage(error.response.data.message);
      }
    },
  },
};
